module.exports = __webpack_public_path__ + "img/InformationSecurity.62c0e770.png";